// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2nWsa","question":"Question_question__3gIwo","description":"Question_description__1UcpC"};